/*
  Grilluxe Quantity-Stepper — minimales Vanilla-JS, wiederverwendet auf PDP
  (Add-to-Cart-Formular) und Cart-Page (Mengenänderung pro Zeile). Kein externer
  Code, keine Library. Menge darf nicht unter 1 (PDP) bzw. unter 0 (Cart, 0 =
  Zeile beim nächsten "Aktualisieren" entfernen) fallen.
*/
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-qty-stepper]").forEach(function (stepper) {
    var input = stepper.querySelector("[data-qty-input]");
    var decrementBtn = stepper.querySelector("[data-qty-decrement]");
    var incrementBtn = stepper.querySelector("[data-qty-increment]");
    if (!input) return;

    var min = parseInt(input.getAttribute("min"), 10);
    if (isNaN(min)) min = 1;

    function setValue(value) {
      if (value < min) value = min;
      input.value = value;
    }

    if (decrementBtn) {
      decrementBtn.addEventListener("click", function () {
        var current = parseInt(input.value, 10) || min;
        setValue(current - 1);
      });
    }

    if (incrementBtn) {
      incrementBtn.addEventListener("click", function () {
        var current = parseInt(input.value, 10) || min;
        setValue(current + 1);
      });
    }

    input.addEventListener("change", function () {
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = min;
      setValue(current);
    });
  });
});
